/* eslint-disable react-hooks/exhaustive-deps */
import {
  Chip,
  Icon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { FC, useState, useEffect } from "react";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { CollectionUtil } from "src/framework/commons/CollectionUtil";
import { Mppt } from "../../types";
import { notifierStore } from "src/framework/store/NotifierStore";
import { InputInteger } from "src/framework/components/forms/inputs/InputInteger";

export interface MpptsProperties {
  list: Mppt[];
  tensaoMaximaEntrada: number;
  correnteMaximaEntradaString: number;
  onAdd: (mppt: Mppt) => void;
  onUpdate: (mpptList: Mppt[]) => void;
  onRemove: (numero: number) => void;
}

const Mppts: FC<MpptsProperties> = ({
  list = [],
  tensaoMaximaEntrada = 0,
  correnteMaximaEntradaString = 0,
  onAdd = () => { },
  onRemove = () => { },
  onUpdate = () => { },
}) => {
  const [qtdValue, setQtdValue] = useState<string>("");
  const [mpptList, setMpptList] = useState<Mppt[]>([]);

  const [correnteMaxima, setCorrenteMaxima] = React.useState<number>(
    correnteMaximaEntradaString
  );
  const [tensaoMaxima, setTensaoMaxima] =
    React.useState<number>(tensaoMaximaEntrada);

  useEffect(() => {
    setCorrenteMaxima(correnteMaximaEntradaString);
    setTensaoMaxima(tensaoMaximaEntrada);

    if (list.length > 0) {
      for (let idx in list) {
        list[idx].corrente = correnteMaximaEntradaString;
      }

      onUpdate(list);
    }
  }, [tensaoMaximaEntrada, correnteMaximaEntradaString]);

  useEffect(() => {
    setMpptList(list);
  },
    [list]
  );

  const removeMppt = (idx: number): void => {
    list.splice(idx, 1);
    onUpdate(list);
  }

  const avisoQtdStringExcedido = (): void => {
    notifierStore.setNotifier({
      title: "Aviso!!!",
      content: `A quantidade de strings deve ser entre 1 e 4`,
      timeOut: 2500,
      onClose: () => {
        notifierStore.setOpen(false);
      }
    });
    notifierStore.setOpen(true);
  }

  return (
    <div className="row X--start X--middle">
      <div className="X12 M2">
        <InputInteger
          label={"Quantidade de strings"}
          value={qtdValue}
          fullWidth
          allowNegative={false}
          maxLength={3}
          onChangeValue={(name: any, value: any) => {
            setQtdValue(value);
          }}
        />
      </div>
      <div className="X12 M1">
        <IconButton
          onClick={() => {
            const _value = parseInt(`${qtdValue === "" ? "0" : qtdValue}`);
            if (_value > 4 || _value === 0) {
              avisoQtdStringExcedido();
              return;
            }

            onAdd({
              quantidade: parseInt(qtdValue),
              numero: list.length + 1,
              corrente: correnteMaximaEntradaString,
            });
          }}
          size="large">
          <Icon>add</Icon>
        </IconButton>
      </div>
      <div className="X12"></div>
      {list.length > 0 ? (
        <div className="X12">
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Quantidade strings</TableCell>
                  <TableCell>Corrente máxima/string</TableCell>
                  <TableCell>Tensão máxima CC</TableCell>
                  <TableCell>Corrente máxima/MPPT</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mpptList.sort(CollectionUtil.singleSort("numero")).map((mppt, idx: number) => {

                  let disabled: boolean = false;

                  if (mppt?.created_at) {
                    disabled = true;
                  }

                  return (
                    <TableRow
                      key={`componente-mppt-${idx}`}
                    >
                      <TableCell>{`MPPT-${mppt.numero}`}</TableCell>
                      <TableCell>
                        <InputInteger
                          value={list[idx].quantidade.toString()}
                          name={`mppt-${mppt.numero}`}
                          onChangeValue={(name: any, value: any) => {
                            const _value = value || 0

                            if (parseInt(_value) > 4 || parseInt(_value) === 0) {
                              avisoQtdStringExcedido();
                              return;
                            }

                            list[idx].quantidade = parseInt(_value);
                            setMpptList([...mpptList])
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          size={"small"}
                          icon={
                            <Icon
                              style={{
                                fontSize: "16px",
                                color: "orange",
                              }}
                            >
                              flash_on
                            </Icon>
                          }
                          label={
                            Formater.toString(
                              correnteMaxima,
                              TypeRecords.DECIMAL2
                            ) + " A"
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          size={"small"}
                          icon={
                            <Icon
                              style={{
                                fontSize: "16px",
                                color: "orange",
                              }}
                            >
                              flash_on
                            </Icon>
                          }
                          label={
                            Formater.toString(
                              tensaoMaxima || 0,
                              TypeRecords.INT
                            ) + " A"
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          size={"small"}
                          icon={
                            <Icon
                              style={{
                                fontSize: "16px",
                                color: "orange",
                              }}
                            >
                              flash_on
                            </Icon>
                          }
                          label={
                            Formater.toString(
                              parseFloat(correnteMaxima.toString()) *
                              mppt.quantidade,
                              TypeRecords.DECIMAL2
                            ) + " A"
                          }
                        />
                      </TableCell>
                      <TableCell >
                        <IconButton
                          disabled={disabled}
                          onClick={() => {
                            if (!disabled) {
                              removeMppt(idx)
                            }
                          }}
                          size="large">
                          <Icon color={disabled ? "inherit" : "error"}>delete</Icon>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        ""
      )}
      <div className="X12"></div>
    </div>
  );
};

export { Mppts };


